import React from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { DayPickerRangeController } from 'react-dates'

import InvisibleButton from 'components/display/InvisibleButton'
import AvailableWeekends from '../common/AvailableWeekends'

import FilterButton from './FilterButton'

const Wrapper = styled.div`
  .DayPicker {
    box-shadow: none;
  }
`

const ViewTabs = styled.div`
  margin: 0 -16px;
  padding: 0 16px;

  border-bottom: 1px solid ${({ theme }) => theme?.['-ds-neutral-300']?.value};

  margin-bottom: 24px;

  & > *:not(:last-child) {
    margin-right: 24px;
  }
`

const Tab = styled(InvisibleButton)`
  position: relative;
  padding: 12px 0;
  font-weight: 400;
  color: ${({ theme, active }) =>
    active
      ? theme?.['-ds-core-400']?.value
      : theme?.['-ds-neutral-700']?.value};

  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-xs']?.['font-size']?.value};

  ${({ active, theme }) =>
    active &&
    `
    border-bottom: 2px solid ${theme?.['-ds-core-400']?.value};
  `}
`

const SEARCH_TYPE_SPECIFIC_DATES = 'specific-dates'
const SEARCH_TYPE_AVAILABLE_WEEKENDS = 'available-weekends'

const getInitialDateSearchType = (props) => {
  if (props.weekendMonths?.length > 0) {
    return SEARCH_TYPE_AVAILABLE_WEEKENDS
  }

  return SEARCH_TYPE_SPECIFIC_DATES
}

class DatesFilter extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      dateSearchType: getInitialDateSearchType(props),
      startDate: props.startDate ? moment(props.startDate) : null,
      endDate: props.endDate ? moment(props.endDate) : null,
      weekendMonths: props?.weekendMonths || null,
      focusedInput: 'startDate',
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      startDate: nextProps.startDate ? moment(nextProps.startDate) : null,
      endDate: nextProps.endDate ? moment(nextProps.endDate) : null,
      weekendMonths: nextProps?.weekendMonths || null,
    })
  }

  onApply = () => {
    const { dateSearchType, weekendMonths } = this.state
    const { onChange } = this.props

    if (dateSearchType === SEARCH_TYPE_AVAILABLE_WEEKENDS) {
      onChange({ weekendMonths })
      return
    }

    const { startDate, endDate } = this.state
    onChange({ startDate, endDate })
  }

  onReset = () => {
    const { startDate, endDate } = this.props
    this.setState({
      startDate: startDate ? moment(startDate) : null,
      endDate: endDate ? moment(endDate) : null,
    })
  }

  onDatesChange = ({ startDate, endDate }) => {
    this.setState({ startDate, endDate })
  }

  onDatesClear = () => {
    const { onChange } = this.props
    this.setState({
      startDate: null,
      endDate: null,
      weekendMonths: null,
      focusedInput: 'startDate',
    })
    onChange({ startDate: null, endDate: null, weekendMonths: null })
  }

  onFocusChange = (focusedInput) => {
    this.setState({
      focusedInput: !focusedInput ? 'startDate' : focusedInput,
    })
  }

  getLabel = () => {
    const { startDate, endDate, dateSearchType, weekendMonths } = this.state
    if (
      dateSearchType === SEARCH_TYPE_AVAILABLE_WEEKENDS &&
      weekendMonths?.length > 0
    ) {
      return 'Weekends'
    }
    const formatDate = (d) => moment(d).format('DD MMM')
    const fomattedStart = startDate ? formatDate(startDate) : 'Start'
    const fomattedEnd = endDate ? formatDate(endDate) : 'End'
    return startDate || endDate ? `${fomattedStart} - ${fomattedEnd}` : 'Dates'
  }

  render() {
    const { isActive, ...props } = this.props
    const {
      dateSearchType,
      weekendMonths,
      startDate,
      endDate,
      focusedInput,
    } = this.state

    return (
      <FilterButton
        label={this.getLabel()}
        onApply={this.onApply}
        onClear={this.onDatesClear}
        onReset={this.onReset}
        isActive={props.startDate || props.endDate || props.weekendMonths}
      >
        <Wrapper>
          <ViewTabs>
            <Tab
              active={dateSearchType === 'specific-dates'}
              onClick={() =>
                this.setState({ dateSearchType: SEARCH_TYPE_SPECIFIC_DATES })
              }
            >
              Specific dates
            </Tab>
            <Tab
              active={dateSearchType === 'available-weekends'}
              onClick={() =>
                this.setState({
                  dateSearchType: SEARCH_TYPE_AVAILABLE_WEEKENDS,
                })
              }
            >
              Available weekends
            </Tab>
          </ViewTabs>

          {dateSearchType === SEARCH_TYPE_SPECIFIC_DATES && (
            <DayPickerRangeController
              startDate={startDate}
              endDate={endDate}
              onDatesChange={this.onDatesChange}
              focusedInput={focusedInput}
              onFocusChange={this.onFocusChange}
              numberOfMonths={2}
              hideKeyboardShortcutsPanel
              isOutsideRange={(day) => day.isBefore(moment().startOf('day'))}
              firstDayOfWeek={1}
            />
          )}

          {dateSearchType === SEARCH_TYPE_AVAILABLE_WEEKENDS && (
            <AvailableWeekends
              selectedValues={weekendMonths || []}
              onChange={({ value, checked }) => {
                if (checked) {
                  this.setState({
                    weekendMonths: [...(weekendMonths || []), value],
                  })
                } else {
                  this.setState({
                    weekendMonths: (weekendMonths || []).filter(
                      (v) => v !== value
                    ),
                  })
                }
              }}
            />
          )}
        </Wrapper>
      </FilterButton>
    )
  }
}

export default DatesFilter
